import {
  MAX_LEARNED_LIBRARY_FILE_BYTES,
  parseLearnedAutoFillLibraryDocument,
  serializeLearnedAutoFillLibrary,
  type LearnedAutoFillLibraryParseResult,
  type LearnedAutoFillPatternV1,
} from '../../../shared/lib/quickFill/learnedAutoFillLibrary';

export async function readQuickFillKeyLibraryFile(
  file: Pick<File, 'size' | 'text'>
): Promise<LearnedAutoFillLibraryParseResult> {
  if (file.size > MAX_LEARNED_LIBRARY_FILE_BYTES) {
    return { ok: false, error: 'The dictionary file exceeds the 1 MiB limit.' };
  }

  let raw: string;
  try {
    raw = await file.text();
  } catch {
    return { ok: false, error: 'The selected dictionary file could not be read.' };
  }

  return parseLearnedAutoFillLibraryDocument(raw);
}

export function downloadQuickFillKeyLibrary(
  entries: readonly LearnedAutoFillPatternV1[],
  exportedAt = new Date().toISOString()
): void {
  const blob = new Blob(
    [serializeLearnedAutoFillLibrary(entries, exportedAt)],
    { type: 'application/json' }
  );
  const downloadUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = downloadUrl;
  anchor.download = `pipeex-key-dictionary-${exportedAt.slice(0, 10)}.json`;
  document.body.appendChild(anchor);

  try {
    anchor.click();
  } finally {
    anchor.remove();
    URL.revokeObjectURL(downloadUrl);
  }
}
